import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import { renderKisilerGrid } from "../kisilerGrid.js";
import { uiState } from "../../../state/uiState.js";

const API = "/api";
let didBind = false;

function ensureKisilerDeleteDialog() {
	if (document.getElementById("kisilerDeleteDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="kisilerDeleteDialog">
    <div class="delete-dialog-container">
        <div class="delete-dialog-header">
            <div class="delete-header-icon kisiler-toggle-header-icon">
                <span class="material-icons kisiler-toggle-header-icon-inner" style="font-size:22px">person_off</span>
            </div>
            <h2 class="kisiler-toggle-title">Ki\u015fiyi Pasife Al</h2>
            <button class="delete-dialog-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
        <hr class="delete-divider" />
        <div class="delete-dialog-body">
            <p class="kisiler-toggle-body-text">Bu ki\u015fiyi pasife almak istedi\u011finizden emin misiniz?</p>
            <div class="delete-dialog-card">
                <div class="delete-card-icon">
                    <span class="material-icons" style="font-size:20px;color:#6b7280">badge</span>
                </div>
                <div class="delete-card-info">
                    <span class="delete-dialog-id kisiler-delete-tc"></span>
                    <span class="delete-dialog-name kisiler-delete-name"></span>
                </div>
            </div>
            <div class="kisiler-toggle-warning delete-dialog-warning">
                <span class="material-icons kisiler-toggle-warning-icon" style="font-size:17px;flex-shrink:0;margin-top:1px">info</span>
                <span class="kisiler-toggle-warning-text">Ki\u015fi sistemde pasif olarak i\u015faretlenecektir.</span>
            </div>
        </div>
        <div class="delete-dialog-buttons">
            <button class="delete-cancel">\u0130ptal</button>
            <button class="delete-confirm kisiler-toggle-confirm-btn">
                <span class="material-icons kisiler-toggle-confirm-icon" style="font-size:16px">person_off</span>
                <span class="kisiler-toggle-confirm-text">Pasife Al</span>
            </button>
        </div>
    </div>
</dialog>`);
}

export function initKisilerDeleteDialog() {
	ensureKisilerDeleteDialog();
	const dialog = document.querySelector("#kisilerDeleteDialog");
	if (!dialog || didBind) return;
	didBind = true;

	let pendingTc = null;
	let pendingIsActive = true;

	window.openKisilerDeleteDialog = (tc, label, isActive) => {
		pendingTc = tc;
		pendingIsActive = isActive;

		dialog.querySelector(".kisiler-delete-tc").textContent = tc;
		dialog.querySelector(".kisiler-delete-name").textContent = label ?? "";

		const headerIcon = dialog.querySelector(".kisiler-toggle-header-icon");
		const headerIconInner = dialog.querySelector(".kisiler-toggle-header-icon-inner");
		const warning = dialog.querySelector(".kisiler-toggle-warning");
		const warningIcon = dialog.querySelector(".kisiler-toggle-warning-icon");
		const confirmBtn = dialog.querySelector(".kisiler-toggle-confirm-btn");
		const confirmIcon = dialog.querySelector(".kisiler-toggle-confirm-icon");

		if (isActive) {
			headerIcon.style.background = "#fef3c7";
			headerIconInner.textContent = "person_off";
			headerIconInner.style.color = "#d97706";
			dialog.querySelector(".kisiler-toggle-title").textContent = "Ki\u015fiyi Pasife Al";
			dialog.querySelector(".kisiler-toggle-body-text").textContent = "Bu ki\u015fiyi pasife almak istedi\u011finizden emin misiniz?";
			warning.style.background = "#fffbeb";
			warning.style.borderLeftColor = "#f59e0b";
			warning.style.color = "#92400e";
			warningIcon.textContent = "pause_circle";
			dialog.querySelector(".kisiler-toggle-warning-text").textContent = "Ki\u015fi pasif olarak i\u015faretlenecek, sistemde g\u00f6r\u00fcnmeyecektir.";
			confirmBtn.style.background = "#f59e0b";
			confirmBtn.style.borderColor = "#f59e0b";
			confirmIcon.textContent = "person_off";
			dialog.querySelector(".kisiler-toggle-confirm-text").textContent = "Pasife Al";
		} else {
			headerIcon.style.background = "#dcfce7";
			headerIconInner.textContent = "how_to_reg";
			headerIconInner.style.color = "#16a34a";
			dialog.querySelector(".kisiler-toggle-title").textContent = "Ki\u015fiyi Aktife Al";
			dialog.querySelector(".kisiler-toggle-body-text").textContent = "Bu ki\u015fiyi aktife almak istedi\u011finizden emin misiniz?";
			warning.style.background = "#f0fdf4";
			warning.style.borderLeftColor = "#22c55e";
			warning.style.color = "#166534";
			warningIcon.textContent = "check_circle";
			dialog.querySelector(".kisiler-toggle-warning-text").textContent = "Ki\u015fi aktif olarak i\u015faretlenecek, sisteme eri\u015fimi a\u00e7\u0131lacakt\u0131r.";
			confirmBtn.style.background = "#22c55e";
			confirmBtn.style.borderColor = "#22c55e";
			confirmIcon.textContent = "how_to_reg";
			dialog.querySelector(".kisiler-toggle-confirm-text").textContent = "Aktife Al";
		}

		dialog.showModal();
	};

	dialog.addEventListener("click", (e) => {
		if (e.target.closest(".delete-dialog-close") || e.target.closest(".delete-cancel")) {
			dialog.close();
		}
	});

	dialog.querySelector(".delete-confirm").addEventListener("click", async () => {
		if (!pendingTc) return;
		const tc = pendingTc;
		const newIsActive = pendingIsActive ? 0 : 1;

		showDialogOverlay(dialog, "G\u00fcncelleniyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const res = await fetch(`${API}/kisiler/${encodeURIComponent(tc)}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ is_active: newIsActive }),
			});
			if (!res.ok) throw new Error(`HTTP ${res.status}`);

			dialog.close();
			Toastify({
				text: newIsActive === 0 ? "Ki\u015fi pasife al\u0131nd\u0131." : "Ki\u015fi aktife al\u0131nd\u0131.",
				duration: 3000,
				gravity: "top",
				position: "right",
				style: { background: "#22c55e", borderRadius: "8px", fontSize: "14px", fontWeight: "500" },
			}).showToast();

			const refreshUrl = uiState.kisiler.lastSearchUrl ?? `${API}/kisiler`;
			renderKisilerGrid({ url: refreshUrl, paginationLimit: uiState.kisiler.paginationLimit });
		} catch (err) {
			console.error("Kisi durum degistirme hatasi:", err);
			Toastify({
				text: "\u0130\u015flem s\u0131ras\u0131nda hata olu\u015ftu.",
				duration: 3000,
				gravity: "top",
				position: "right",
				style: { background: "#ee4447", borderRadius: "8px", fontSize: "14px", fontWeight: "500" },
			}).showToast();
		} finally {
			hideDialogOverlay();
		}
	});
}
